import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fetchContentTag } from 'actions/ContentActions'

interface UseContentTagResult {
  contentTag: App.ContentTag | null
}

/**
 * Hook to fetch and access ContentTag from Redux store
 * @param slug - The ContentTag slug to fetch
 * @returns Object containing contentTag
 */
function useContentTag(slug: string | undefined): UseContentTagResult {
  const dispatch = useAppDispatch()

  const contentTag = useAppSelector(state => {
    if (!slug) {
      return null
    }
    return state.content.contentTags[slug] ?? null
  })

  useEffect(() => {
    if (!slug) {
      return
    }

    dispatch(fetchContentTag(slug))
  }, [dispatch, slug])

  return {
    contentTag,
  }
}

export default useContentTag
